import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, Mark, Xp } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { clubs } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Club = () => {
  const { saved, markSaved } = useWeb();

  return (
    <>
      <div className="web-hero green">
        <h2>Find your people, build your passion</h2>
        <p>Join clubs, attend events, and make an impact.</p>
        <Icon name="users" className="float" />
      </div>
      <Chips group="clubs" options={['My Clubs', 'All Clubs', 'Events']} />
      <div className="web-grid three">
        {clubs.map((club) => {
          const going = Boolean(saved[club.id]);
          return (
            <article className="web-card" key={club.id}>
              <Mark name={club.icon} from={club.from} to={club.to} />
              <h2 style={{ fontSize: 18, margin: '12px 0 4px' }}>{club.title}</h2>
              <div className="web-mut">Next event: {club.event}</div>
              <div className="web-mut">{club.members} members · <Xp amount={club.xp} signed={false} /></div>
              <button type="button" className={`web-btn${going ? ' ok' : ''}`} style={{ marginTop: 14 }} onClick={() => markSaved(club.id, 'RSVP confirmed')}>
                {going ? 'Going' : 'RSVP'}
              </button>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default Club;
